export const hasNavicomputer = (vehicle) =>
    !!vehicle?.NaviComputer && vehicle.NaviComputer !== "false";

export const hasAstromechSocket = (vehicle) => {
    if (!vehicle || hasNavicomputer(vehicle)) return false;
    if (vehicle.AstromechSocket === true || vehicle.AstromechSocket === "true") return true;
    if (vehicle.AstromechSocket === false || vehicle.AstromechSocket === "false") return false;
    return /astromech/i.test(vehicle.Crew || "");
};
